<a *ngIf="user" class="tile tile-centered header-element {{ theme }}" [routerLink]="['/user/account']">
  <div class="tile-icon">
    <i class="fa fa-user-circle fa-fw centered"></i>
  </div>
</a>